/** Primitive answer plus the exact document revision captured as checklist evidence. */
export interface ChecklistAnswer {
  value: string | number | boolean | null;
  photoDocumentId?: string;
  photoVersionId?: string;
}

/** Normalize plain answers and the persisted evidence wrapper without unsafe casts. */
export function checklistAnswer(input: unknown): ChecklistAnswer {
  const wrapped = typeof input === "object" && input !== null && "value" in input;
  const value = wrapped ? input.value : input;
  return {
    value:
      typeof value === "string" || typeof value === "number" || typeof value === "boolean"
        ? value
        : null,
    photoDocumentId:
      wrapped && "photo_document_id" in input && typeof input.photo_document_id === "string"
        ? input.photo_document_id
        : undefined,
    photoVersionId:
      wrapped && "photo_version_id" in input && typeof input.photo_version_id === "string"
        ? input.photo_version_id
        : undefined,
  };
}
